<main class="monitoring-page">
 
  <section class="panel filter-panel">
    <div class="filters">
      <label
        >Type<select
          [value]="selectionType()"
          (change)="changeSelectionType($any($event.target).value)"
        >
          <option value="QCA">QCA</option>
          <option value="Generator">Generator</option>
        </select></label
      >
      @if (selectionType() === "QCA") {
        <label
          >QCA<select
            [value]="selectedQcaId()"
            (change)="changeQca($any($event.target).value)"
          >
            @for (qca of qcas; track qca.qca_id) {
              <option [value]="qca.qca_id">{{ qca.name }}</option>
            }
          </select></label
        >
      } @else {
      <label
        >Generator<select
          [value]="selectedGeneratorId()"
          (change)="changeGenerator($any($event.target).value)"
        >
          @for (generator of generators; track generator.generator_id) {
            <option [value]="generator.generator_id" [selected]="generator.generator_id === selectedGeneratorId()">
              {{ generator.name }}
            </option>
          }
        </select></label
      >
      }
      <label
        >Unit<select
          [value]="selectedUnitId() ?? ''"
          (change)="changeUnit($any($event.target).value)"
        >
          <option value="">All generator units</option>
          @for (unit of units(); track unit.unit_id) {
            <option [value]="unit.unit_id">
              {{ unit.unit_name }} ({{ unit.rated_capacity_mw }} MW)
            </option>
          }
        </select></label
      >
      <label
        >Schedule Type<select
          [value]="scheduleType()"
          (change)="changeScheduleType($any($event.target).value)"
        >
          <option>Day Ahead</option>
          <option>Intraday </option>
          <option>Weekday</option>

        </select></label
      >
      <label
        >Schedule Date<input
          type="date"
          [value]="scheduleDate()"
          (change)="changeScheduleDate($any($event.target).value)"
      /></label>
      <div class="filter-actions">
        <button class="search app-button app-button--primary" type="button" (click)="search()">
          ⌕&nbsp; Search</button
        ><button class="reset app-button app-button--secondary" type="button" (click)="reset()">Reset</button>
         <button
    class="upload app-button app-button--primary"
    type="button"
    (click)="navigateToScheduleUpload()">
    Add Schedule
  </button>
      </div>
    </div>
  </section>

  <section class="panel analytics-panel">
    <div class="kpis">
      <article>
        <span>Total Blocks</span><strong>96</strong><small>Blocks</small>
      </article>
      <article>
        <span>Max Schedule (MW)</span
        ><strong class="green">{{ maxSchedule() | number: "1.2-2" }}</strong
        ><small>at Block {{ maxScheduleBlock() }}</small>
      </article>
      <article>
        <span>Min Schedule (MW)</span
        ><strong class="red">{{ minSchedule() | number: "1.2-2" }}</strong
        ><small>at Block {{ minScheduleBlock() }}</small>
      </article>
      <article>
        <span>Max Actual (MW)</span
        ><strong class="blue">{{ maxActual() | number: "1.2-2" }}</strong
        ><small>at Block {{ maxActualBlock() }}</small>
      </article>
      <article>
        <span>Min Actual (MW)</span
        ><strong class="orange">{{ minActual() | number: "1.2-2" }}</strong
        ><small>at Block {{ minActualBlock() }}</small>
      </article>
      <article>
        <span>Total Energy (MWh)</span
        ><strong class="blue">{{
          totalScheduleEnergy() | number: "1.2-2"
        }}</strong
        ><small>Actual: {{ totalActualEnergy() | number: "1.2-2" }}</small>
      </article>
      <article>
        <span>Avg Deviation (MW)</span
        ><strong class="purple">{{
          averageDeviation() | number: "1.2-2"
        }}</strong
        ><small
          >{{
            (totalScheduleEnergy()
              ? ((totalActualEnergy() - totalScheduleEnergy()) /
                  totalScheduleEnergy()) *
                100
              : 0
            ) | number: "1.2-2"
          }}%</small
        >
      </article>
    </div>
    <div class="view-actions">
      <button
        type="button" class="app-button app-button--secondary"
        [class.active]="activeView() === 'graph'"
        (click)="setView('graph')"
      >
        ⌁&nbsp; Graph</button
      ><button
        type="button" class="app-button app-button--secondary"
        [class.active]="activeView() === 'table'"
        (click)="setView('table')"
      >
        ▦&nbsp; Table
      </button>
    </div>
    @if (activeView() === "graph") {
      <div #blockChartPanel class="block-chart-panel">
        <div class="chart-controls">
          <label><select [value]="chartXAxisMode()" (change)="changeChartXAxisMode($any($event.target).value)"><option value="time">Time-wise</option><option value="block">Block-wise</option></select></label>
          <div class="chart-actions">
            <button type="button" title="View chart in full screen" aria-label="View block chart in full screen" (click)="toggleBlockChartFullscreen(blockChartPanel)">⛶</button>
          </div>
        </div>
        <div class="chart"><div #blockChart class="block-highchart"></div></div>
      </div>
    } @else {
      <p class="table-hint">The complete 96-block schedule is shown below.</p>
    }
  </section>

  <section class="panel table-panel">
    <header>
      <div>
        <h1>Uploaded Schedule &amp; Actual Data</h1>
        <p>
          Generator: <b>{{ generator()?.name || "-" }}</b> <i></i> Unit:
          <b>{{ selectedUnitLabel() }}</b> <i></i> Schedule Type:
          <b>{{ scheduleType() }}</b> <i></i> Schedule Date:
          <b>{{ scheduleDate() }}</b>
        </p>
      </div>
      <small>Showing all {{ rows().length }} of 96 blocks</small>
    </header>
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Block No.</th>
            <th>Time Block</th>
            <th>Schedule (MW)</th>
            <th>Actual (MW)</th>
            <th>Deviation (MW)</th>
            <th>Deviation (%)</th>
            <th>Available Capacity (MW)</th>
            <th>Cumulative Energy - Schedule (MWh)</th>
            <th>Cumulative Energy - Actual (MWh)</th>
            
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.blockNo) {
            <tr>
              <td>{{ row.blockNo }}</td>
              <td>{{ formatTime(row.blockNo) }}</td>
              <td>{{ row.scheduleMw | number: "1.2-2" }}</td>
              <td>{{ row.actualCapacityMw | number: "1.2-2" }}</td>
              <td [class.negative]="row.deviation < 0">
                {{ row.deviation | number: "1.2-2" }}
              </td>
              <td [class.negative]="row.deviationPercent < 0">
                {{ row.deviationPercent | number: "1.2-2" }}%
              </td>
              <td>{{ row.availableCapacity | number: "1.2-2" }}</td>
              <td>{{ row.cumulativeSchedule | number: "1.2-2" }}</td>
              <td>{{ row.cumulativeActual | number: "1.2-2" }}</td>
             
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</main>
